<template>
  <div v-if="shipping.id">
    <div v-if="!singleItem">
      <item-autocomplete
        @selected="itemSelected"
        :placeholder="this.$gettext('Reference, or External ID')"
        :includes="['item_tracking', 'shipping']"
        :restrict-to="[['active', 'eq', 1]]"
      />
      <b-badge v-for="(item, index) in items" :key="'item' + index" class="mr-1">
        {{ item.reference_code | cleanentityprefix }}
        <b-badge variant="danger" href="#" @click.prevent="removeItem(index)">×</b-badge>
      </b-badge>
    </div>
    <div v-else>
      <item-autocomplete
        @selected="itemSelected"
        :placeholder="this.$gettext('Reference, or External ID')"
        v-if="!items[0]"
        :includes="['item_tracking', 'shipping']"
        :restrict-to="[['active', 'eq', 1]]"
      />
      <h5 v-else>
        <b-badge variant="dark" v-for="(item, index) in items" :key="'item' + index" class="mr-1">
          {{ item.reference_code | cleanentityprefix }}
          <b-badge variant="danger" href="#" @click.prevent="removeItem(index)">×</b-badge>
        </b-badge>
      </h5>
    </div>
    <b-button class="mt-1" size="sm" v-translate="{itemsLabel: ecosystemModules.items.label || $gettext('Items')}" @click="updateItemsData">Update %{itemsLabel} Data</b-button>
  </div>
</template>

<script>
import { ItemService } from '@/services/api'
import ItemAutocomplete from '@/components/Autocompletes/ItemAutocomplete'

export default {
  name: 'EditFieldItems',
  components: {
    ItemAutocomplete
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    singleItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      toRemove: []
    }
  },
  watch: {
    shipping: {
      deep: true,
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue.items) !== JSON.stringify(oldValue.items) && (newValue.items.length === 0 || newValue.items[0].reference_code)) {
          this.items = [...new Set(newValue.items)]
        }
      }
    }
  },
  mounted () {
    if (this.shipping.items.length === 0 || this.shipping.items[0].reference_code) {
      this.items = [...new Set(this.shipping.items)]
    }
  },
  methods: {
    itemSelected(item) {
      if (this.items.findIndex(x => x.id === item.id) === -1) {
        this.items.push(item)
      }
    },
    removeItem(index) {
      this.toRemove.push(this.items[index])
      this.items.splice(index, 1)
    },
    async updateItemsData() {
      for (const item of this.toRemove) {
        await ItemService.removeFromShipping(item.item_id, this.shipping.id)
      }
      this.toRemove = []
      for (const item of this.items) {
        await ItemService.addToShipping(item.id, this.shipping.id)
      }
      this.$emit('updated', true)
    }
  }
}
</script>
